import { render, staticRenderFns } from "./subheader.vue?vue&type=template&id=a5b06130&scoped=true"
import script from "./subheader.vue?vue&type=script&lang=js"
export * from "./subheader.vue?vue&type=script&lang=js"
import style0 from "./subheader.vue?vue&type=style&index=0&id=a5b06130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b06130",
  null
  
)

export default component.exports